<template>
  <v-btn color="primary" large rounded @click.stop="handleCartButtonClick">
    <img class="mr-3" alt="cart" src="@/assets/cart/cart-icon.svg" height="28" width="28" />
    <div class="font-size-md text-capitalize e2e-cart">Cart</div>
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "CartButton",
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" })
  },
  methods: {
    handleCartButtonClick() {
      if (this.$route.name === "checkout") {
        this.$store.commit("orders/OPEN_BACK_TO_CART_DIALOG");
      } else {
        this.authorized
          ? this.$store.commit("cart/SET", true)
          : this.openAuthAndComeBackToCart();
      }
    },
    openAuthAndComeBackToCart() {
      this.$store.commit("auth/OPEN", true);
      const unsubscribe = store.subscribe((mutation) => {
        if (this.$store.getters["auth/isAuthenticated"] && mutation.type === "store/UPDATE") {
          this.$store.commit("cart/SET", true);
          unsubscribe();
        }
      });
    }
  }
};
</script>
